export default "__VITE_ASSET__ebdc18c8__"